<!-- MOLECULE: AppBarActionButton.vue -->
<!-- Icon button with tooltip used in the app-bar actions row. -->

<script setup lang="ts">
//
// Props & Emits
//
withDefaults(
  defineProps<{
    icon: string;
    tooltipText: string;
    loading?: boolean;
    onClick?: () => void;
  }>(),
  {
    loading: false,
    onClick: () => {},
  },
);
</script>

<template>
  <v-tooltip location="bottom" :open-delay="700" :close-delay="300">
    <template #activator="{ props }">
      <v-btn icon v-bind="props" @click="onClick">
        <!-- Loading state -->
        <v-progress-circular v-if="loading" size="20" width="2" indeterminate color="white" />

        <!-- Normal state -->
        <v-icon v-else size="default" :icon="icon" />
      </v-btn>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>
